import React from 'react';
import {
	useModalDialogActions,
	useReturnFocusTo,
} from '@atlassian/jira-software-modal-dialog/src/controllers/index.tsx';
import MoveModal from './index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MoveModalWrapper = (props: any): React.JSX.Element => {
	const returnFocusTarget = useReturnFocusTo();
	const { setReturnFocusTo } = useModalDialogActions();

	return (
		<MoveModal
			{...props}
			returnFocusTarget={returnFocusTarget}
			setReturnFocusTo={setReturnFocusTo}
		/>
	);
};

export default MoveModalWrapper;
